export default "__VITE_ASSET__D9MGDo0Q__"